
import {createSlice} from '@reduxjs/toolkit'
import { fetchindiJobStatus } from '../../action/master/indiJobStatusAction'

interface indiJobStatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: indiJobStatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const indiJobStatusSlice = createSlice({
  name: 'indiJobStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchindiJobStatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchindiJobStatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchindiJobStatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default indiJobStatusSlice.reducer
